import { reactive } from 'vue'

export const env = reactive({
  debug: true,
  // domain: 'https://dev-api.hifunclub.com',
  domain: 'http://127.0.0.1:8080',
  version: '',
  platform: '',
  language: 'zh_Hant',
  statusBarHeight: 25,
})
